import { FC } from "react";

import { AccessibilityProps } from "capitalrx-components-2.0/lib/AccessibilityProps";
import { BaseProps } from "capitalrx-components-2.0/lib/BaseProps";
import { getHtmlPropsFromBaseProps } from "capitalrx-components-2.0/lib/utilities";

import { createComponentStyleHook } from "../../tokens";

import legacyStyles from "./legacy/styles.module.scss";
import tokenStyles from "./styles.module.css";

const useStyles = createComponentStyleHook<DividerProps>({
  legacyStyles,
  tokenStyles,
  componentTokens: "horizontal_line",
});

export interface DividerProps extends BaseProps, AccessibilityProps {
  /**
   * The divider orientation. `"horizontal"` (default) draws a top border for
   * stacked content; `"vertical"` draws a left border for inline separation.
   */
  readonly orientation?: "horizontal" | "vertical";
}

export const Divider: FC<DividerProps> = (props) => {
  const { className, role = "separator", orientation = "horizontal" } = props;
  const { mode, styles, StyleModeBoundary } = useStyles(props);

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.Divider, orientation === "vertical" ? styles.Vertical : styles.Horizontal, className],
    testIdPrefix: "divider  ",
  });

  const ariaOrientation = role === "presentation" || role === "none" ? undefined : orientation;

  return (
    <StyleModeBoundary mode={mode}>
      <hr {...baseHtmlProps} role={role} aria-orientation={ariaOrientation} />
    </StyleModeBoundary>
  );
};
